import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentCargoTypesAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentCargo`,
    method: 'get',
  });
};

export type ShipmentCargoTypesResponse = {
  codeId: string;
  codeDesc: string;
  value1: null;
  value2: null;
  value3: null;
  string1: null;
  string2: null;
  string3: null;
}[];

export const fetchShipmentCargoTypesList = async (): Promise<ShipmentCargoTypesResponse> => {
  const response: AxiosResponse<ShipmentCargoTypesResponse> = await getShipmentCargoTypesAPI();
  return response.data;
};
